(function () {
  function initModestMobileMenu() {
    var details = document.querySelector('details[data-mobile-menu]');
    var drawer = document.querySelector('.mm-mobile-drawer');
    var menu = document.getElementById('mobile_menu');
    var scrim = document.querySelector('[data-mm-mobile-menu-scrim]');

    if (!details || !drawer || !menu || drawer.dataset.mmMenuReady === 'true') return;

    document.documentElement.classList.add('mm-v3-header-active');
    drawer.dataset.mmMenuReady = 'true';
    drawer.classList.add('mm-drilldown-ready');

    var summary = details.querySelector('[data-mobile-menu-trigger]');
    var icon = details.querySelector('[data-mobile-menu-icon]');
    var searchTrigger = document.querySelector('[data-mm-mobile-search-trigger]');
    var drawerSearch = drawer.querySelector('#mm-mobile-menu-search');

    function isVisible(element) {
      if (!element) return false;

      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.height > 0 &&
        rect.width > 0
      );
    }

    function setMenuTop() {
      var topBar = document.querySelector('#header .top-bar');
      var top = 0;

      if (topBar && isVisible(topBar)) {
        top = topBar.getBoundingClientRect().bottom;
      }

      if (!top || top < 0 || top > 420) {
        top = 0;
      }

      document.documentElement.style.setProperty('--mm-mobile-menu-top', Math.round(top) + 'px');
    }

    function setIconState(isOpen) {
      if (icon) {
        icon.classList.toggle('open', isOpen);
      }

      if (summary) {
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }

    function resetPanels() {
      menu.querySelectorAll('.mm-panel-active').forEach(function (panel) {
        panel.classList.remove('mm-panel-active');
      });
    }

    function markOpen() {
      details.open = true;
      document.body.classList.add('is-active');
      document.documentElement.classList.add('is-active');
      setIconState(true);
      setMenuTop();
    }

    function markClosed() {
      resetPanels();
      details.open = false;
      details.removeAttribute('open');
      document.body.classList.remove('is-active');
      document.documentElement.classList.remove('is-active');
      setIconState(false);
    }

    function isMenuOpen() {
      return (
        document.body.classList.contains('is-active') ||
        details.open ||
        (
          window.mobileMenuDrawer &&
          window.mobileMenuDrawer.animation &&
          window.mobileMenuDrawer.animation.state === 'open'
        )
      );
    }

    function openMenu() {
      setMenuTop();

      if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.open === 'function') {
        window.mobileMenuDrawer.open();
        window.setTimeout(markOpen, 20);
      } else {
        markOpen();
      }
    }

    function closeMenu() {
      resetPanels();

      if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.close === 'function') {
        window.mobileMenuDrawer.close();
        window.setTimeout(markClosed, 80);
      } else {
        markClosed();
      }
    }

    function getDirectChildUl(li) {
      for (var i = 0; i < li.children.length; i += 1) {
        if (li.children[i].tagName && li.children[i].tagName.toLowerCase() === 'ul') {
          return li.children[i];
        }
      }

      return null;
    }

    function getTitleFromLink(link) {
      var titleNode = link.querySelector('[data-nav-title], .mobile-menu-item-title');
      var title = titleNode ? titleNode.textContent : link.textContent;

      return title.replace(/\s+/g, ' ').trim();
    }

    function preparePanel(panel, title) {
      if (panel.dataset.mmPanelReady === 'true') return;

      panel.dataset.mmPanelReady = 'true';

      var headerLi = document.createElement('li');
      headerLi.className = 'mm-drilldown-header';

      var backButton = document.createElement('button');
      backButton.type = 'button';
      backButton.className = 'mm-drilldown-back';
      backButton.setAttribute('aria-label', 'Back');

      var arrow = document.createElement('span');
      arrow.textContent = '‹';

      var text = document.createElement('span');
      text.textContent = title;

      backButton.appendChild(arrow);
      backButton.appendChild(text);
      headerLi.appendChild(backButton);

      panel.insertBefore(headerLi, panel.firstChild);

      backButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        panel.classList.remove('mm-panel-active');
      });
    }

    if (window.jQuery) {
      window.jQuery('#mobile_menu li.sublink > a').off('click.mobileAccordion');
    }

    if (summary) {
      summary.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          if (isMenuOpen()) {
            closeMenu();
          } else {
            openMenu();
          }
        },
        true
      );
    }

    if (searchTrigger) {
      searchTrigger.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          openMenu();

          window.setTimeout(function () {
            if (drawerSearch) drawerSearch.focus({ preventScroll: true });
          }, 140);
        },
        true
      );
    }

    menu.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a');

        if (!link || !menu.contains(link)) return;

        var li = link.closest('li');
        var panel = li ? getDirectChildUl(li) : null;

        if (!panel) {
          if (link.hasAttribute('data-mm-menu-close')) {
            closeMenu();
          }
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        preparePanel(panel, getTitleFromLink(link));
        panel.classList.add('mm-panel-active');
        panel.scrollTop = 0;
      },
      true
    );

    if (scrim) {
      scrim.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeMenu();
        },
        true
      );
    }

    details.addEventListener('toggle', function () {
      setMenuTop();

      if (details.open) {
        document.body.classList.add('is-active');
        document.documentElement.classList.add('is-active');
        setIconState(true);
      } else {
        resetPanels();
        document.body.classList.remove('is-active');
        document.documentElement.classList.remove('is-active');
        setIconState(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

    window.addEventListener('resize', setMenuTop);

    window.addEventListener('orientationchange', function () {
      window.setTimeout(setMenuTop, 160);
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.promo-banner__close')) return;
      document.body.classList.remove('promo-banner--show');
      document.cookie = 'promo-banner=dismiss; path=/; max-age=2592000; SameSite=Lax';
      window.setTimeout(setMenuTop, 160);
    });

    setMenuTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModestMobileMenu);
  } else {
    initModestMobileMenu();
  }

  window.addEventListener('load', function () {
    window.setTimeout(initModestMobileMenu, 180);
  });
})();
